export const GET_THREADS = 'GET_THREADS'
export const CREATE_THREAD = 'CREATE_THREAD'
export const GET_THREAD_MESSAGES = 'GET_THREAD_MESSAGES'
export const READ_THREAD_MESSAGES = 'READ_THREAD_MESSAGES'
export const SEND_THREAD_MESSAGE = 'SEND_THREAD_MESSAGE'
export const GET_MESSAGING_CONTACTS = 'GET_MESSAGING_CONTACTS'
export const SEARCH_MESSAGES = 'SEARCH_MESSAGES'
export const REPORT_MESSAGE = 'REPORT_MESSAGE'
export const BLOCK_MESSAGING_USER = 'BLOCK_MESSAGING_USER'
export const UNBLOCK_MESSAGING_USER = 'UNBLOCK_MESSAGING_USER'
export const SET_MESSAGING_OFFICE_HOURS = 'SET_MESSAGING_OFFICE_HOURS'
export const ADD_THREAD_PARTICIPANTS = 'ADD_THREAD_PARTICIPANTS'
export const MUTE_THREAD = 'MUTE_THREAD'
export const GET_MESSAGING_ADMIN_THREADS = 'GET_MESSAGING_ADMIN_THREADS'
export const GET_MESSAGING_ADMIN_REPORTS = 'GET_MESSAGING_ADMIN_REPORTS'
export const UPDATE_MESSAGING_ADMIN_REPORT = 'UPDATE_MESSAGING_ADMIN_REPORT'
export const GET_MESSAGING_ADMIN_BLOCKS = 'GET_MESSAGING_ADMIN_BLOCKS'
export const SUSPEND_MESSAGING_USER = 'SUSPEND_MESSAGING_USER'
export const GET_MESSAGING_SETTINGS = 'GET_MESSAGING_SETTINGS'
export const UPDATE_MESSAGING_SETTINGS = 'UPDATE_MESSAGING_SETTINGS'
